import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { BranchACQ134CompanySize } from './branches/BranchACQ134CompanySize';
import { BranchACQ134VariantA } from './branches/BranchACQ134VariantA';
import { BranchACQ134VariantB } from './branches/BranchACQ134VariantB';
import { BranchMicroapps } from './branches/BranchMicroapps';
import { BranchCmsBusinessMaturity } from './branches/BranchCmsBusinessMaturity';
import { BranchCSFE0014Variant } from './branches/BranchCSFE0014Variant';
import { BranchCookielessWordpress } from './branches/BranchCookielessWordpress';
import { BranchOptionalPhoneNumber } from './branches/BranchOptionalPhoneNumber';
import { BranchQuestionFallback } from './branches/BranchQuestionFallback';
import { ProductSetupUIBranch } from './branches/ProductSetupUIBranch';
import { BranchACQ140VariantA } from './branches/BranchACQ140VariantA';
import { BranchACQ140VariantB } from './branches/BranchACQ140VariantB';
import { BranchACQ140CompanySize } from './branches/BranchACQ140CompanySize';
const DefaultBranches = [BranchQuestionFallback];
const softwareSignupBranches = [...DefaultBranches, BranchOptionalPhoneNumber];
export const FlowBranches = {
  [Flow.Crm]: [...softwareSignupBranches, BranchACQ134VariantA, BranchACQ134VariantB, BranchACQ134CompanySize, BranchACQ140VariantA, BranchACQ140VariantB, BranchACQ140CompanySize, BranchMicroapps],
  [Flow.Marketing]: [...softwareSignupBranches, BranchMicroapps, BranchACQ134VariantA, BranchACQ134VariantB, BranchACQ134CompanySize, BranchACQ140VariantA, BranchACQ140VariantB, BranchACQ140CompanySize],
  [Flow.Sales]: [...softwareSignupBranches, ProductSetupUIBranch, BranchACQ134VariantA, BranchACQ134VariantB, BranchACQ134CompanySize, BranchACQ140VariantA, BranchACQ140VariantB, BranchACQ140CompanySize],
  [Flow.Service]: [...softwareSignupBranches, BranchACQ134VariantA, BranchACQ134VariantB, BranchACQ134CompanySize, BranchACQ140VariantA, BranchACQ140VariantB, BranchACQ140CompanySize],
  [Flow.CmsFree]: [BranchCSFE0014Variant, BranchCmsBusinessMaturity, ...softwareSignupBranches],
  [Flow.Integrations]: [BranchCookielessWordpress]
};
export const getFlowBranches = () => {
  return FlowBranches[getFlowKey()] || DefaultBranches;
};